import { render, staticRenderFns } from "./FeedBackDrawer.vue?vue&type=template&id=2954be37&scoped=true&"
import script from "./FeedBackDrawer.vue?vue&type=script&lang=js&"
export * from "./FeedBackDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackDrawer.vue?vue&type=style&index=0&id=2954be37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2954be37",
  null
  
)

export default component.exports